import { render } from "./ItemRanking.vue?vue&type=template&id=dbc49d92&scoped=true"
import script from "./ItemRanking.vue?vue&type=script&lang=js"
export * from "./ItemRanking.vue?vue&type=script&lang=js"

import "./ItemRanking.vue?vue&type=style&index=0&id=dbc49d92&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc49d92"]])

export default __exports__